import { useState, useEffect } from 'react'
import FormSection from './FormSection'
import { translations } from '../../data/translations'

const ShopSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.shop || translations.de.shop
  const [showShopDetails, setShowShopDetails] = useState(false)

  useEffect(() => {
    if (formData.shop_benoetigt === 'ja') {
      setShowShopDetails(true)
    } else {
      setShowShopDetails(false)
    }
  }, [formData.shop_benoetigt])

  const handleCheckboxChange = (field, value) => {
    const currentValues = formData[field] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(field, newValues)
  }

  const handleShopChange = (value) => {
    updateFormData('shop_benoetigt', value)
    setShowShopDetails(value === 'ja')
  }

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      {/* 8. Shop-Bedarf */}
      <div className="form-group">
        <label>{t.shopBenoetigt} <span className="required">*</span></label>
        <div className="radio-group">
          {t.shopOptionen.map(option => (
            <div key={option.value} className="radio-item">
              <input
                type="radio"
                id={`shop-${option.value}`}
                name="shop_benoetigt"
                value={option.value}
                checked={formData.shop_benoetigt === option.value}
                onChange={(e) => handleShopChange(e.target.value)}
              />
              <label htmlFor={`shop-${option.value}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>

      {showShopDetails && (
        <>
          {/* 8.1 Produkt-Informationen */}
          <div className="subsection">
            <div className="subsection-title">{t.subtitle1}</div>
            
            <div className="form-group">
              <label>{t.produktAnzahl}</label>
              <div className="radio-group">
                {t.produktAnzahlOptionen.map(option => (
                  <div key={option.value} className="radio-item">
                    <input
                      type="radio"
                      id={`prod-${option.value}`}
                      name="produkt_anzahl"
                      value={option.value}
                      checked={formData.produkt_anzahl === option.value}
                      onChange={(e) => updateFormData('produkt_anzahl', e.target.value)}
                    />
                    <label htmlFor={`prod-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className="form-group">
              <label>{t.produktTyp}</label>
              <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
                {t.produktTypOptionen.map(option => (
                  <div key={option.value} className="checkbox-item">
                    <input
                      type="checkbox"
                      id={`prod-typ-${option.value}`}
                      checked={(formData.produkt_typ || []).includes(option.value)}
                      onChange={() => handleCheckboxChange('produkt_typ', option.value)}
                    />
                    <label htmlFor={`prod-typ-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* 8.2 Shop-Features */}
          <div className="subsection">
            <div className="subsection-title">{t.subtitle2}</div>
            
            <div className="form-group">
              <label>{t.shopFeatures}</label>
              <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
                {t.shopFeaturesOptionen.map(option => (
                  <div key={option.value} className="checkbox-item">
                    <input
                      type="checkbox"
                      id={`shop-feat-${option.value}`}
                      checked={(formData.shop_features || []).includes(option.value)}
                      onChange={() => handleCheckboxChange('shop_features', option.value)}
                    />
                    <label htmlFor={`shop-feat-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
            </div>

            <div className="form-group">
              <label>{t.zahlungsmethoden}</label>
              <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))' }}>
                {t.zahlungsmethodenOptionen.map(option => (
                  <div key={option.value} className="checkbox-item">
                    <input
                      type="checkbox"
                      id={`pay-${option.value}`}
                      checked={(formData.zahlungsmethoden || []).includes(option.value)}
                      onChange={() => handleCheckboxChange('zahlungsmethoden', option.value)}
                    />
                    <label htmlFor={`pay-${option.value}`}>{option.label}</label>
                  </div>
                ))}
              </div>
              <input
                type="text"
                name="zahlungsmethoden_weitere"
                value={formData.zahlungsmethoden_weitere || ''}
                onChange={(e) => updateFormData('zahlungsmethoden_weitere', e.target.value)}
                placeholder={t.zahlungsmethodenWeitere}
                style={{ marginTop: '10px' }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="versandanbieter">{t.versandanbieter}</label>
              <input
                type="text"
                id="versandanbieter"
                name="versandanbieter"
                value={formData.versandanbieter || ''}
                onChange={(e) => updateFormData('versandanbieter', e.target.value)}
                placeholder={t.versandanbieterPlaceholder}
              />
            </div>
          </div>
        </>
      )}
    </FormSection>
  )
}

export default ShopSection
